// extracted by mini-css-extract-plugin
module.exports = {"blueLink":"CardChoiceConfirmation-module__blueLink___3tq-w","viewDetailsLink":"CardChoiceConfirmation-module__viewDetailsLink___3MwmV"};